import { cssVar, styled, Tab } from '@cad-arc';

const FrStyledTab = styled(Tab)<{ $tabsQuantity: number }>`
    & > span {
        justify-content: center;
    }
    width: ${({ $tabsQuantity }) => `calc(100%/${$tabsQuantity})`};
    background-color: ${cssVar('arc.colors.surface.foreground')};
`;

export function FrTab({
    type,
    icon,
    totalTabCount,
    title,
    onClick,
}: {
    type: string;
    icon: string;
    totalTabCount: number;
    title: string;
    onClick: () => void;
}) {
    return (
        <FrStyledTab
            value={type}
            leadingVisual={icon}
            $tabsQuantity={totalTabCount}
            onClick={onClick}
        >
            {title}
        </FrStyledTab>
    );
}
